import React, { useContext, useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ReactQuill from "react-quill";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { AppContext } from "../context/AppContext";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";
import Editor from "@monaco-editor/react";
import "react-quill/dist/quill.snow.css";

import * as Md from "react-icons/md";

function UpdateContents() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [updateState, setUpdateState] = useState({
    page_slug: "",
    section_name: "",
    content_key: "",
    position: 0,
    content_value: "",
  });
  const [errors, setErrors] = useState({});
  const [isRichText, setIsRichText] = useState(true);
  const [code, setCode] = useState("");

  // const searchParams
  const {
    sortedContents,
    contentLoading,
    updateContent,
    fetchAllContentsData,
    fetchAllContentsDataNew,
  } = useContext(AppContext);

  const handleEditorChange = (value) => {
    setUpdateState((prev) => ({ ...prev, content_value: value }));
    setCode(value);
  };

  const handleToggle = async () => {
    setIsRichText(!isRichText);
    // await fetchAllContentsData();
  };

  useEffect(() => {
    if (!id || !sortedContents) return;

    const content =
      sortedContents.length != 0 && sortedContents.find((x) => x.id == id);

    if (!content) return;

    console.log(content, "content");

    setUpdateState({
      page_slug: content.page_slug,
      section_name: content.section_name,
      content_key: content.content_key,
      position: content.position,
      content_value: content.content_value,
    });
    setCode(content.content_value);
  }, [id, sortedContents]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUpdateState((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const validationErrors = {};
    let isValid = true;

    // Check each field for emptiness
    if (!updateState.slug) {
      validationErrors.slug = "Slug is required";
      isValid = false;
    }

    if (!updateState.section_name) {
      validationErrors.section_name = "Section name is required";
      isValid = false;
    }

    if (!updateState.content_key) {
      validationErrors.content_key = "Content key is required";
      isValid = false;
    }

    if (updateState.position <= 0) {
      validationErrors.position = "Position cannot be 0 or less";
      isValid = false;
    }

    if (!updateState.content_value) {
      validationErrors.content_value = "Content value is required";
      isValid = false;
    }

    setErrors(validationErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateForm();

    if (isValid) return;

    const payload = {
      ...updateState,
      id: id,
    };

    await updateContent(payload, {
      onSuccess: async (res) => {
        console.log(res);
        toast.success("content updated Successfully!");

        await fetchAllContentsData();
        await fetchAllContentsDataNew();

        navigate("/contents");
      },
      onFailed: (err) => {
        toast.error("Content is not updated!");
      },
    });
  };

  return (
    <MasterLayout>
      <div class="content-form-container">
        <div class="content-form-wrapper">
          <button
            type="button"
            className="back_btn"
            onClick={() => navigate(-1)}
          >
            <Md.MdKeyboardArrowLeft /> Back
          </button>
          {/* Instructions Below the Form */}
          <div className="form-instructions">
            <h3 className="fs-6 text-danger">Important Instructions</h3>
            <ul>
              <li>
                <strong>Immediate Changes:</strong> If you change the content,
                it will affect immediately on the system. You will need to
                reload the page to see the updated data.
              </li>
              <li>
                <strong>Be Cautious with Section Name and Content Key:</strong>{" "}
                Don't change the section name or content key unless you are
                absolutely sure. Modifying these values without knowledge may
                directly affect the live website.
              </li>
            </ul>
          </div>
          <br />
          <div class="content-form-header">
            <h1 class="content-form-title fs-5">Content Management Form</h1>
          </div>

          <form class="content-management-form" onSubmit={handleSubmit}>
            <div class="content-form-field-group">
              <label for="sectionName" class="content-form-label">
                Slug <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                id="sectionName"
                name="page_slug"
                class="content-form-input"
                placeholder="Enter section name"
                value={updateState.page_slug}
                onChange={handleChange}
                required
              />
              {updateState.page_slug.length == 0 && errors.slug && (
                <span className="text-danger" style={{ fontSize: "12px" }}>
                  {errors.slug}
                </span>
              )}
            </div>
            <div class="content-form-field-group">
              <label for="sectionName" class="content-form-label">
                Section Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                id="sectionName"
                name="section_name"
                class="content-form-input"
                placeholder="Enter section name"
                value={updateState.section_name}
                onChange={handleChange}
                required
              />
              {updateState.section_name.length == 0 && errors.section_name && (
                <span className="text-danger" style={{ fontSize: "12px" }}>
                  {errors.section_name}
                </span>
              )}
            </div>

            <div class="content-form-field-group">
              <label for="contentKey" class="content-form-label">
                Content Key <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                id="contentKey"
                name="content_key"
                class="content-form-input"
                placeholder="Enter content key"
                value={updateState.content_key}
                onChange={handleChange}
                required
              />
              {updateState.content_key.length == 0 && errors.content_key && (
                <span className="text-danger" style={{ fontSize: "12px" }}>
                  {errors.content_key}
                </span>
              )}
            </div>

            <div class="content-form-field-group">
              <label for="position" class="content-form-label">
                Position <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                id="position"
                name="position"
                class="content-form-input"
                placeholder="Enter position number"
                value={updateState.position}
                onChange={handleChange}
              />
              {updateState.position == 0 && errors.position && (
                <span className="text-danger" style={{ fontSize: "12px" }}>
                  {errors.position}
                </span>
              )}
            </div>

            <div class="content-form-field-group">
              <label for="content" class="content-form-label">
                Content <span className="text-danger">*</span>
              </label>
              {/* <button
                type="button"
                onClick={handleToggle}
                className="toggle-editor-btn"
              >
                {isRichText ? "Edit with HTML tags" : "Switch to Rich Text"}
              </button> 
              <span className="info__">
                * If you are using more internal tags for styling, we recommend
                the HTML Editor over the text editor.
              </span>*/}
              <div className="content-rich-editor-wrapper">
                <ReactQuill
                  theme="snow"
                  value={updateState.content_value}
                  onChange={(e) =>
                    setUpdateState((prev) => ({ ...prev, content_value: e }))
                  }
                  modules={{
                    toolbar: [
                      ["bold", "italic", "underline", "strike"],
                      [{ header: [1, 2, 3, false] }],
                      [{ color: [] }, { background: [] }],
                      ["blockquote", "code-block"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      [{ align: [] }],
                      ["link", "image"],
                      ["clean"],
                    ],
                  }}
                  formats={[
                    "header",
                    "bold",
                    "italic",
                    "underline",
                    "strike",
                    "blockquote",
                    "code-block",
                    "list",
                    "bullet",
                    "indent",
                    "link",
                    "image",
                    "color",
                    "background",
                    "align",
                    "clean",
                  ]}
                />
                {/* {isRichText ? (
                  
                ) : (
                  <Editor
                    height="300px"
                    defaultLanguage="html"
                    language="html"
                    theme="vs-dark"
                    value={code}
                    onChange={handleEditorChange}
                    options={{
                      fontSize: 14,
                      minimap: { enabled: false },
                      automaticLayout: true,
                      wordWrap: "on",
                      formatOnPaste: false,
                      formatOnType: false,
                      renderWhitespace: "all", // Ensures all spaces are preserved
                      tabSize: 2, // Makes sure indentation is correct
                    }}
                  />
                )} */}

                {updateState.content_value.length == 0 &&
                  errors.content_value && (
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.content_value}
                    </span>
                  )}
              </div>
            </div>

            <button
              type="submit"
              class="content-form-submit"
              disabled={contentLoading}
            >
              {!contentLoading ? (
                " Submit"
              ) : (
                <PulseLoader color="#fff" size={10} />
              )}
            </button>
          </form>
        </div>
      </div>
    </MasterLayout>
  );
}

export default UpdateContents;
